import React from 'react';
import { useBreakpoint } from '../../../../../shared/hooks/useBreakpoint';

export function SplitViewCardSkeleton() {
  const { isXs } = useBreakpoint();

  if (isXs) {
    return (
      <article className="rounded-lg shadow-sm border bg-white flex max-h-[300px] h-full w-full animate-pulse">
        {/* Image */}
        <div className="w-[150px] bg-gray-200 rounded-l-lg rounded-r-none" />

        {/* Content */}
        <div className="px-2 py-3 flex flex-col w-full">
          {/* Header */}
          <div className="flex flex-col gap-2 pb-2 border-b-2 border-gray-200">
            <div className="h-4 w-3/4 bg-gray-200 rounded mx-auto" />
            <div className="flex flex-row justify-evenly">
              <div className="h-3 w-10 bg-gray-200 rounded" />
              <div className="h-3 w-10 bg-gray-200 rounded" />
              <div className="h-3 w-14 bg-gray-200 rounded" />
            </div>
          </div>

          {/* Body */}
          <div className="pt-2 h-full px-2 grid grid-cols-[1fr,2fr] gap-y-2 items-center">
            <div className="h-3 w-12 bg-gray-200 rounded" />
            <div className="h-5 w-20 bg-gray-300 rounded ml-auto" />

            <div className="h-3 w-16 bg-gray-200 rounded" />
            <div className="h-5 w-20 bg-gray-300 rounded ml-auto" />

            <div className="h-3 w-24 bg-gray-200 rounded" />
            <div className="h-6 w-24 bg-gray-300 rounded ml-auto" />

            <div className="col-span-2 h-3 w-1/2 bg-gray-200 rounded mx-auto mt-2" />
          </div>
        </div>
      </article>
    );
  }

  // Desktop
  return (
    <article className="flex rounded-lg shadow-sm border bg-white h-[220px] animate-pulse">
      {/* Image */}
      <div className="w-[260px] h-[200px] bg-gray-200 rounded-l-lg rounded-r-none" />

      {/* Content */}
      <div className="px-6 py-3 flex flex-col w-[475px]">
        {/* Header */}
        <div className="flex justify-between gap-2 pb-2 border-b-2 border-gray-200">
          <div className="h-4 w-1/2 bg-gray-200 rounded" />
          <div className="flex gap-4">
            <div className="h-3 w-10 bg-gray-200 rounded" />
            <div className="h-3 w-10 bg-gray-200 rounded" />
            <div className="h-3 w-14 bg-gray-200 rounded" />
          </div>
        </div>

        {/* Body */}
        <div className="pt-2 flex items-center h-full">
          {/* Left */}
          <div className="basis-1/3 grid grid-rows-2 h-full pr-6 border-r-2 border-gray-200 gap-2">
            <div className="flex flex-col gap-1">
              <div className="h-3 w-12 bg-gray-200 rounded" />
              <div className="h-5 w-20 bg-gray-300 rounded" />
            </div>
            <div className="flex flex-col gap-1">
              <div className="h-3 w-16 bg-gray-200 rounded" />
              <div className="h-5 w-20 bg-gray-300 rounded" />
            </div>
          </div>

          {/* Right */}
          <div className="basis-2/3 flex flex-col justify-center items-center gap-2">
            <div className="h-3 w-20 bg-gray-200 rounded" />
            <div className="h-7 w-24 bg-gray-300 rounded" />
            <div className="h-3 w-28 bg-gray-200 rounded mt-2" />
          </div>
        </div>
      </div>
    </article>
  );
}
